export const BREAKPOINTS = {
  xsMax: '360px',
  smMin: '361px',
  smMax: '860px',
  mdMin: '861px',
  mdMax: '1039px',
  lgMin: '1040px',
  lgMax: '1279px',
  xlMin: '1280px',
};
